import colors from "tailwindcss/colors";

export const CHART_COMPLETE_COLOR = "#6366f1";
export const CHART_INCOMPLETE_COLOR = "#9ca3af";

export const PIE_CHART_COLORS = [
  colors.purple[700],
  colors.purple[500],
  colors.purple[400],
  colors.purple[300],
  colors.purple[200],
  colors.orange[200],
  colors.orange[300],
  colors.orange[400],
  colors.orange[500],
  colors.orange[700],
];

export const BAR_CHART_COLORS = [
  colors.purple[700],
  colors.purple[500],
  colors.purple[400],
  colors.orange[700],
  colors.orange[500],
  colors.orange[400],
  colors.blue[700],
  colors.blue[500],
  colors.blue[400],
  colors.gray[700],
  colors.gray[500],
  colors.gray[400],
];

export type RechartPieChartData = {
  name: string;
  value: number;
  color: string;
};
